module.exports = __webpack_public_path__ + "./fonts/Pacifico_400Regular.ttf";